import script from "./manpower.vue?vue&type=script&lang=js&setup=true"
export * from "./manpower.vue?vue&type=script&lang=js&setup=true"

import "./manpower.vue?vue&type=style&index=0&id=0fada7fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fada7fe"]])

export default __exports__